import { render, staticRenderFns, recyclableRender, components } from "./changePassword.vue?vue&type=template&id=70814534&scoped=true&"
var renderjs
import script from "./changePassword.vue?vue&type=script&lang=js&"
export * from "./changePassword.vue?vue&type=script&lang=js&"
import style0 from "./changePassword.vue?vue&type=style&index=0&lang=css&"
import style1 from "./changePassword.vue?vue&type=style&index=1&id=70814534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70814534",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/changePassword/changePassword.vue"
export default component.exports